/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Confirmation_TitleInputs */

const en_meta_showcase_confirmation_title = /** @type {(inputs: Meta_Showcase_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Confirmation Page for Hotel Websites | Lindevo`)
};

const lv_meta_showcase_confirmation_title = /** @type {(inputs: Meta_Showcase_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervācijas apstiprinājuma lapa viesnīcai | Lindevo`)
};

/**
* | output |
* | --- |
* | "Booking Confirmation Page for Hotel Websites \| Lindevo" |
*
* @param {Meta_Showcase_Confirmation_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_confirmation_title = /** @type {((inputs?: Meta_Showcase_Confirmation_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Confirmation_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_confirmation_title(inputs)
	return en_meta_showcase_confirmation_title(inputs)
});